<p class="paragraph">
  <ng-content></ng-content>
</p>
